import { Icon } from 'components/atoms';
import styled, { css } from 'styled-components';
import fontService, { FontWeight } from 'services/FontService';
import { CardSlotVariants, WinnerVariants } from './ListCards';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 592px;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(18, 16, 17, 0.6) 0%, #121011 86.04%);
`;

export const ResultValueBG = styled(Icon)`
  position: absolute;
  top: 0;
  left: 50%;
  height: 600px !important;
  width: auto !important;
  transform: translateX(-50%);
`;

export const CardGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 2;
  justify-content: center;
  gap: 20px;
  width: 100%;
  top: -44px;
`;

export const CardInfoStatus = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
`;

export const CardSlot = styled.div<{
  $variant: CardSlotVariants;
  $active?: boolean;
  $winnerHighlight?: WinnerVariants | null;
}>`
  position: relative;
  box-sizing: border-box;
  width: 86px;
  height: 132px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;

  ${({ $variant, $active, $winnerHighlight }) => {
    if ($variant === CardSlotVariants.Empty)
      return css`
        border: ${$active ? '2px solid #43ac1d' : '1px solid #686868'};
        background: ${$active
          ? 'linear-gradient(180deg, rgba(60, 128, 36, 0.2) 28.96%, #3C8024 100%), #434343'
          : '#434343'};
        box-shadow: -2.93333px 1.46667px 5.86667px rgba(0, 0, 0, 0.2);
      `;
    if ($variant === CardSlotVariants.Filled)
      return css`
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.2) 100%), #ffffff;
        box-shadow: ${$winnerHighlight === WinnerVariants.Player
          ? '0px 0px 16px rgba(87, 181, 227, 0.8), inset 0px 0px 64px rgba(18, 123, 173, 0.4), inset 0px -56px 64px -40px rgba(18, 123, 173, 0.6);'
          : $winnerHighlight === WinnerVariants.Banker
          ? '0px 0px 16px rgba(237, 26, 76, 0.8), inset 0px 0px 64px rgba(208, 1, 50, 0.4), inset 0px -56px 64px -40px rgba(208, 1, 50, 0.6)'
          : $winnerHighlight === WinnerVariants.Tie
          ? '0px 0px 16px rgba(67, 172, 29, 0.8), inset 0px 0px 64px rgba(60, 128, 36, 0.4), inset 0px -56px 64px -40px rgba(60, 128, 36, 0.6)'
          : '-3.13944px 1.56972px 6.27888px rgba(0, 0, 0, 0.2), inset 0px 0.78486px 0.78486px rgba(18, 16, 17, 0.1), inset 0px -1.56972px 3.13944px rgba(255, 255, 255, 0.8)'};
        svg {
          width: 48px;
          height: 48px;
        }
      `;
    if ($variant === CardSlotVariants.Undefined)
      return css`
        background: linear-gradient(
            180deg,
            rgba(195, 15, 44, 0.04) 50%,
            rgba(195, 15, 44, 0.2) 100%
          ),
          #ffffff;
        border: 1px solid #c30f2c;
        box-shadow: -3.13333px 1.56667px 6.26667px rgba(0, 0, 0, 0.2),
          inset 0px 0.783333px 0.783333px rgba(18, 16, 17, 0.1),
          inset 0px -1.56667px 3.13333px rgba(255, 255, 255, 0.8);
        svg {
          width: 42px;
          height: 56px;
        }
      `;
  }}
`;

export const WinnerLabel = styled.div<{ $winner: WinnerVariants }>`
  position: absolute;
  z-index: 2;
  top: -54px;
  width: 100%;
  display: flex;
  justify-content: ${({ $winner }) =>
    $winner === WinnerVariants.Banker
      ? 'flex-start'
      : $winner === WinnerVariants.Player
      ? 'flex-end'
      : 'center'};
  padding: 0 82px;
  ${({ theme: { text } }) => css`
    color: ${text.primaryDefault};
  `}
  ${fontService.getFont({ size: 32, lineHeight: 100, weight: FontWeight.bold })};
  text-transform: uppercase;
`;

export const RotatedCardWrapper = styled.div<{ $side: 'left' | 'right' }>`
  width: 132px;
  height: 86px;
  position: relative;
  top: -24px;

  ${CardSlot} {
    width: 100%;
    height: 100%;
    flex-direction: row;
  }
`;

export const SideLabel = styled.div<{ $align: 'left' | 'right' }>`
  ${fontService.getFont({ size: 16, lineHeight: 150, weight: FontWeight.bold })};
  ${({ theme: { text } }) => `
    color: ${text.secondaryDefault};
  `}
  width: 100%;
  text-align: ${({ $align }) => $align};
  margin-top: -16px;
`;
